export const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.00142 17.9999C5.7537 17.9999 4.55708 17.5258 3.6748 16.6819C2.79253 15.838 2.29687 14.6934 2.29688 13.4999C2.29687 12.3065 2.79253 11.1619 3.6748 10.318C4.55708 9.47406 5.7537 8.99995 7.00142 8.99995C7.29611 7.68713 8.15818 6.53343 9.39801 5.79267C10.0119 5.42587 10.7001 5.1715 11.4232 5.04406C12.1463 4.91663 12.8903 4.91863 13.6125 5.04995C14.3348 5.18127 15.0213 5.43934 15.6327 5.80943C16.2442 6.17952 16.7686 6.65437 17.1762 7.20688C17.5837 7.75939 17.8664 8.37873 18.008 9.02955C18.1496 9.68036 18.1473 10.3499 18.0014 10.9999H19.0014C19.9297 10.9999 20.8199 11.3687 21.4763 12.0251C22.1327 12.6815 22.5014 13.5717 22.5014 14.4999C22.5014 15.4282 22.1327 16.3184 21.4763 16.9748C20.8199 17.6312 19.9297 17.9999 19.0014 17.9999H18.0014"
      stroke="#262626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 15L12 12L15 15"
      stroke="#262626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12V21"
      stroke="#262626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
